import { getHreflangs } from "./getHreflangs";

export { getHreflangs };
